'use client';

import type { IProductDetail } from '@/api/types/public';
import { usePriceChangeDialog } from '../hooks/usePriceChangeDialog';

/** 将弹窗订阅限制在稳定的叶子节点，保留原 hook 的判断、计时器和请求行为。 */
export default function PriceChangeDialogController({
  productInfo,
  loginProductInfo,
}: {
  productInfo: IProductDetail;
  loginProductInfo: IProductDetail;
}) {
  usePriceChangeDialog(productInfo, loginProductInfo);
  return null;
}
